/**
 * @license
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://raw.githubusercontent.com/l-lin/angular-datatables/master/LICENSE
 */

import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataTable360Directive } from './angular-datatables.directive';

@NgModule({
  imports: [ CommonModule ],
  declarations: [ DataTable360Directive ],
  exports: [ DataTable360Directive ]
})
export class DataTables360Module {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: DataTables360Module
    };
  }
}
